
function initDummyFilterBtn(){
  const dummyBtn = document.querySelector('.js-collection-filter-btn')
  const realBtn = document.querySelector('.js-collection-filter-btn-real')

  if(dummyBtn){
    dummyBtn.addEventListener('click', () => {
      realBtn.click()
    })
  }
}


function initPDPproperties(){
  const message = document.querySelector('#p-message')
  const messageInput = document.querySelector('.pdp-message')
  const additionalInfo = document.querySelector('#additional-information')
  const additionalInfoInput = document.querySelector('.pdp-additional-information')
  const paperInput = document.querySelector('.pdp-wrapping-paper')
  const colourBtns = document.querySelectorAll('.btn--wrapping')
  const datePicker = document.querySelector('.delivery-date')
  const dateInput = document.querySelector('.pdp-delivery-date')

  if (!datePicker) {

  console.log('no date picker');
    return;
  }

  console.log('date picker');

  dateInput.value = datePicker.value  

  datePicker.addEventListener('change', () => {
    dateInput.value = datePicker.value
    console.log('changed');
  })

  if(message){
    message.addEventListener('change', () => {
      console.log('changed');
      console.log(message.value);
      messageInput.value = message.value
    })
  }

   if(additionalInfo){
    additionalInfo.addEventListener('change', () => {
      additionalInfoInput.value = additionalInfo.value
    })
  }

  if(colourBtns.length){
    colourBtns.forEach((btn) => {

      btn.addEventListener('click', () => {
        console.log(btn);
  
        colourBtns.forEach((col) => {
          col.classList.remove('active')
        })
  
        btn.classList.add('active')
        paperInput.value = btn.getAttribute('data-colour')
      })
    })
  
    colourBtns[0].click()
  }
}

function initCreateYourOwn(){
  const createItem = document.querySelectorAll('.js-cyo-item')
  const itemPlaceholder = document.querySelectorAll('.create-your-own__item-selector')

  if (!itemPlaceholder.length) {
    return
  }

  const itemPlaceholderImage = document.querySelectorAll('.create-your-own__item-selector img')[0].src
  const numberSelected = document.querySelector('.js-cyo-selected-num')
  const mobileToggle = document.querySelector('.create-your-own__selector-header')
  const selectorWrap = document.querySelector('.create-your-own__selector')
  const continueFooter = document.querySelector('.create-your-own__selector-footer')
  const cyoPickedProperriesInput = document.querySelector('.pdp-create-your-own')

  mobileToggle.addEventListener('click', () => {
    if (selectorWrap.classList.contains('open')) {
      selectorWrap.classList.remove('open')
    }else{
      selectorWrap.classList.add('open')
    }
  })   

  let full = false

  function checkIfFull(){
    let amountSelected = document.querySelectorAll('.create-your-own__item-selector.active').length
    numberSelected.innerHTML = amountSelected


    if (amountSelected == itemPlaceholder.length) {
      full = true
      document.querySelector('.product__right-column').classList.add('active')

      let container = document.querySelector('.product__information');
      document.querySelector('.create-your-own__selector-header-left-done').style.display = 'block'
      document.querySelector('.create-your-own__selector-header-left-edit').style.display = 'none'
      continueFooter.classList.add('active')

      let arrayPicked = ""

      itemPlaceholder.forEach((card) => {
        let title = card.querySelector('h3').innerHTML
        arrayPicked = arrayPicked + title + " ✓ "
      })

      cyoPickedProperriesInput.value = arrayPicked

      continueFooter.querySelector('.btn').addEventListener('click', function(){
        container.scrollIntoView()
        selectorWrap.classList.remove('open')
      })

      // container.scrollIntoView()  

    }else{
      full = false
      document.querySelector('.product__right-column').classList.remove('active')
      document.querySelector('.create-your-own__selector-header-left-done').style.display = 'none'
      document.querySelector('.create-your-own__selector-header-left-edit').style.display = 'block'
      continueFooter.classList.remove('active')
      continueFooter.querySelector('.btn').replaceWith(continueFooter.querySelector('.btn').cloneNode(true))
    }
  }

  createItem.forEach((item) => {
    item.addEventListener('click', () => {

      if (!item.classList.contains('selected') && !full) {     
        let image = item.querySelector('img').src
        let title = item.querySelector('h3').innerHTML
        let added = false
        item.classList.add('selected')

        itemPlaceholder.forEach((item) => {   

          if(!item.classList.contains('active') && !added){
            item.classList.add('active')
            item.querySelector('img').src = image
            item.querySelector('h3').innerHTML = title
            added = true
            checkIfFull()
          }

          item.addEventListener('click', () =>{

            if (item.classList.contains('active')) {
              item.classList.remove('active')
              let title = item.querySelector('h3').innerHTML
              item.querySelector('img').src = itemPlaceholderImage
              item.querySelector('h3').innerHTML = "Nothing selected"

              createItem.forEach((item) => {
                let addTitle = item.querySelector('h3').innerHTML

                if (addTitle == title) {       
                  item.classList.remove('selected')
                  checkIfFull()
                }                            
              })              
            }
          })
        })
      }
    })
  })
}

function initCollage(){
  const wrap = document.querySelectorAll('.thumbnail-slider__list')

  if (!wrap.length) {
    return;
  }

  wrap.forEach((wrap) => {
    console.log(wrap);
    let img = wrap.parentNode.querySelector('img')


    if (wrap.querySelector('.mt--first-child-0')) {
      let height = wrap.querySelector('.mt--first-child-0').offsetHeight
      img.style.height = `calc(100% - ${height}px)`    
    }

 
  })
}

function initDragAndScroll(){


  const slider = document.querySelector('.thumbnail-slider__list');
    let isDown = false;
    let startX;
    let scrollLeft;

    if (!slider) {
      return
    }
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });
    slider.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;

    });
}

function initContactForm(){
  const icons = document.querySelectorAll('.field__icon')

  icons.forEach((icon) => {
    let input = icon.parentElement.querySelector('.field__input')

    input.addEventListener('focus', () => {
  
      icon.querySelector('svg path').style.fill = "white"
    })

    input.addEventListener('focusout', () => {
      icon.querySelector('svg path').style.fill = "black"
      // console.log('focused');
    })
  })

  console.log(icons);
}

function addVideoBtn(){
  const videoBtnContainer = document.getElementById("text-template--16328374321410__166264616396cbe282");
  if (videoBtnContainer){
     videoBtnContainer.querySelector('.mt30').innerHTML += '<a href="#" onclick="openModal()" class="btn btn_zoom btn--secondary w-full-sp white"><span>Watch our video</span></a>';
  }
}

function controlVideo(vidFunc) {
  var iframe = document.getElementById("lbh-video");
  iframe.contentWindow.postMessage(
    '{"event":"command","func":"' + vidFunc + '","args":""}',"*");
}

function closeModal(){
     document.getElementById("modal-overlay").style.display = "none";
     document.getElementById("video-homepage").play();
     controlVideo("pauseVideo");
}

function openModal(){
     document.getElementById("modal-overlay").style.display = "block";
     document.getElementById("video-homepage").pause();
     controlVideo("playVideo");
}

 document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
            if (isNotCombinedKey) {
                closeModal()
            }
        }
});

addVideoBtn()
initDummyFilterBtn()
initPDPproperties()
initCreateYourOwn()
initCollage()
initDragAndScroll()
// initContactForm()